import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  DeleteServiceCaller,
  GetServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants/index";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import DeleteModal from "../../../../components/DeletePopUpComponent";

const UserList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Users List"));
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [userListData, setUserListData] = useState([]);
  const [loading, setLoading] = useState(true);
    const [apiStatus, SetApiStatus] = useState(undefined);
  const columns = {
    Code: { text: "Code", align: "start", visible: true },
    Name: { text: "Name", align: "start", visible: true },
    Username: { text: "Username", align: "start", visible: true },
    DefaultExecutive: {
      text: "Default Executive",
      align: "start",
      visible: true,
    },
    IsInActive: { text: "Active", align: "center", visible: true },
    IsLocked: { text: "As Locked", align: "center", visible: true },
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  const fetchUserList = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}rujul/users`);
      if (response.status === 200) {
        SetApiStatus(response.status)
        const cleanedData = response?.data?.data;
        console.log("cleanedData", cleanedData);
        setUserListData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partner Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Partner Master:", error);
    }
  };

  const handleEdit = (id) => {
    console.log("edit ID", id);

    navigate(`/rujul/user-list/edit/${id.ID}`);
  };

  const handleAddNewUser = () => {
    navigate(`/rujul/user-list/add`);
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  // Open the initial delete modal
  const handleDeleteModal = (item) => {
    setShowDeleteModal(true);
    setSelectedDeleteItem(item);
  };

  // Close the delete modal and reset the state
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  // Proceed to confirmation modal
  const handleModalDelete = () => {
    setShowConfirmDeleteModal(true);
    setShowDeleteModal(false);
  };

  // Close the confirm delete modal
  const handleConfirmDeleteClose = () => {
    setShowConfirmDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  // Handle final delete action
  const handleConfirmModalDelete = async () => {
    if (selectedDeleteItem?.ID) {
      await handleDeleteRequest(selectedDeleteItem.ID);
    }
    setShowConfirmDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  // Perform the delete request
  const handleDeleteRequest = async (id) => {
    try {
      await DeleteServiceCaller(`${API_URL}asset-category/${id}`, {}, "delete");
      console.log(`Item with ID ${id} deleted successfully.`);
    } catch (error) {
      console.error("There was an error deleting the item:", error);
    }
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className=" rounded bg-white" id="skill-table-area">
        <div className="row mt-2">
          <Dynamic_PR_table
            data={userListData}
            columns={columns}
            itemsPerPage={10}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            isSrNoRequired={false}
            showIcon1={true}
            showIcon2={false}
            isActionRequired={true}
            isAddNewBtnRequired={true}
            isApiStatus={apiStatus}
            isRequiredStatus={true}
            isSorting={true}
            showIcon3={false}
            showIcon4={false}
            showIcon5={false}
            handleIcon1={handleEdit}
            handleIcon2={handleDeleteModal}
            handleAddNew={handleAddNewUser}
            add
            more
            function
            icons={{
              Icon1: <i class="bi bi-pencil-square icons"></i>,
              Icon1Text: " Edit",
              Icon2: <i class="bi bi-trash-fill icons"></i>,
              Icon2Text: "Delete",
              Icon3: <i class="bi bi-eye-fill icons"></i>,
              Icon4: <i class="bi bi-plus-square icons"></i>,
              Icon4Text: " Add Sub-Contractor",
            }}
          />
        </div>
      </div>

      {/** Delete Confirmation Popup */}
      <DeleteModal
        show={showDeleteModal}
        onClose={handleDeleteClose}
        onConfirm={handleModalDelete}
        message="Are you sure you want to delete this item?"
      />

      {/** Final Confirmation Popup */}
      <DeleteModal
        show={showConfirmDeleteModal}
        onClose={handleConfirmDeleteClose}
        onConfirm={handleConfirmModalDelete}
        message="Really you want to delete this item?"
      />
    </div>
  );
};

export default UserList;
